module.exports = __webpack_public_path__ + "static/media/Staryu_gaussian2.ce93097c.png";